import { render, staticRenderFns } from "./TagEdit.vue?vue&type=template&id=2ca4e348&scoped=true"
import script from "./TagEdit.vue?vue&type=script&lang=js"
export * from "./TagEdit.vue?vue&type=script&lang=js"
import style0 from "./TagEdit.vue?vue&type=style&index=0&id=2ca4e348&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca4e348",
  null
  
)

export default component.exports